<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-payManualOrder">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.userId" placeholder="用户ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.orderNo" placeholder="订单号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.status" placeholder="订单状态" clearable>
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="审核通过" :value="1"></el-option>
            <el-option label="审核拒绝" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm()">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        style="width: 100%;"
        :row-class-name="tableRowClassName">
        <el-table-column prop="id" label="订单ID" header-align="center" align="center" width="80"></el-table-column>
        <el-table-column prop="orderNo" label="订单号" header-align="center" align="center" width="220"></el-table-column>
        <el-table-column prop="userId" label="用户ID" header-align="center" align="center" width="100"></el-table-column>
        <el-table-column prop="userName" label="用户昵称" header-align="center" align="center" width="120"></el-table-column>
        <el-table-column prop="commodityName" label="商品名称" header-align="center" align="center" width="150"></el-table-column>
        <el-table-column prop="commodityType" label="商品类型" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.commodityType === 1" type="warning">金币</el-tag>
            <el-tag v-else-if="scope.row.commodityType === 2" type="success">VIP</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="rechargeAmount" label="充值金额" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <span style="color: #F56C6C; font-weight: bold;">¥{{ scope.row.rechargeAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付凭证" header-align="center" align="center" width="120">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.paymentVoucher"
              :src="scope.row.paymentVoucher"
              :preview-src-list="[scope.row.paymentVoucher]"
              fit="cover"
              style="width: 80px; height: 80px; cursor: pointer;">
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="订单状态" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0" type="warning">待审核</el-tag>
            <el-tag v-else-if="scope.row.status === 1" type="success">审核通过</el-tag>
            <el-tag v-else-if="scope.row.status === 2" type="danger">审核拒绝</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center" width="160"></el-table-column>
        <el-table-column prop="auditUserName" label="审核人" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.auditUserName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="auditTime" label="审核时间" header-align="center" align="center" width="160">
          <template slot-scope="scope">
            {{ scope.row.auditTime || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" header-align="center" align="center" width="180">
          <template slot-scope="scope">
            <template v-if="scope.row.status == 0">
              <el-button
                type="success"
                size="mini"
                @click="handleApprove(scope.row)">
                审核通过
              </el-button>
              <el-button
                type="danger"
                size="mini"
                @click="handleReject(scope.row)">
                审核拒绝
              </el-button>
            </template>
            <template v-else>
              <el-button type="info" size="mini" @click="viewDetail(scope.row)">查看详情</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>

      <!-- 审核拒绝对话框 -->
      <el-dialog title="审核拒绝" :visible.sync="rejectDialogVisible" width="500px">
        <el-form :model="rejectForm" ref="rejectForm" label-width="100px">
          <el-form-item label="拒绝原因" prop="auditRemark">
            <el-select v-model="rejectForm.auditRemark" placeholder="请选择或输入拒绝原因" filterable allow-create>
              <el-option label="支付凭证不清晰" value="支付凭证不清晰"></el-option>
              <el-option label="金额不符" value="金额不符"></el-option>
              <el-option label="重复提交" value="重复提交"></el-option>
              <el-option label="疑似虚假凭证" value="疑似虚假凭证"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="rejectDialogVisible = false">取消</el-button>
          <el-button type="danger" @click="confirmReject">确定拒绝</el-button>
        </span>
      </el-dialog>

      <!-- 详情对话框 -->
      <el-dialog title="订单详情" :visible.sync="detailDialogVisible" width="600px">
        <el-descriptions :column="2" border v-if="currentOrder">
          <el-descriptions-item label="订单号">{{ currentOrder.orderNo }}</el-descriptions-item>
          <el-descriptions-item label="订单状态">
            <el-tag v-if="currentOrder.status === 0" type="warning">待审核</el-tag>
            <el-tag v-else-if="currentOrder.status === 1" type="success">审核通过</el-tag>
            <el-tag v-else-if="currentOrder.status === 2" type="danger">审核拒绝</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="用户ID">{{ currentOrder.userId }}</el-descriptions-item>
          <el-descriptions-item label="用户昵称">{{ currentOrder.userName }}</el-descriptions-item>
          <el-descriptions-item label="商品名称">{{ currentOrder.commodityName }}</el-descriptions-item>
          <el-descriptions-item label="商品类型">
            <el-tag v-if="currentOrder.commodityType === 1" type="warning">金币</el-tag>
            <el-tag v-else-if="currentOrder.commodityType === 2" type="success">VIP</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="商品规格">{{ currentOrder.commoditySpecification }}</el-descriptions-item>
          <el-descriptions-item label="充值金额">¥{{ currentOrder.rechargeAmount }}</el-descriptions-item>
          <el-descriptions-item label="创建时间" :span="2">{{ currentOrder.createDate }}</el-descriptions-item>
          <el-descriptions-item label="审核人" v-if="currentOrder.auditUserName">{{ currentOrder.auditUserName }}</el-descriptions-item>
          <el-descriptions-item label="审核时间" v-if="currentOrder.auditTime">{{ currentOrder.auditTime }}</el-descriptions-item>
          <el-descriptions-item label="审核备注" :span="2" v-if="currentOrder.auditRemark">
            <span style="color: #F56C6C;">{{ currentOrder.auditRemark }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="支付凭证" :span="2">
            <el-image
              v-if="currentOrder.paymentVoucher"
              :src="currentOrder.paymentVoucher"
              :preview-src-list="[currentOrder.paymentVoucher]"
              fit="contain"
              style="width: 300px; height: 300px;">
            </el-image>
          </el-descriptions-item>
        </el-descriptions>
      </el-dialog>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'

export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/payManualOrder/page',
        getDataListIsPage: true
      },
      dataForm: {
        userId: '',
        orderNo: '',
        status: ''
      },
      dateRange: null,
      rejectDialogVisible: false,
      detailDialogVisible: false,
      rejectForm: {
        id: null,
        auditRemark: ''
      },
      currentOrder: null
    }
  },
  watch: {
    dateRange(val) {
      if (!val || val.length === 0) {
        this.dataForm.startDate = null
        this.dataForm.endDate = null
      } else {
        this.dataForm.startDate = val[0]
        this.dataForm.endDate = val[1]
      }
    }
  },
  methods: {
    // 表格行样式
    tableRowClassName({ row }) {
      if (row.status === 0) {
        return 'warning-row'
      }
      return ''
    },

    // 重置表单
    resetForm() {
      this.dataForm = {
        userId: '',
        orderNo: '',
        status: ''
      }
      this.dateRange = null
      this.getDataList()
    },

    // 审核通过
    handleApprove(row) {
      this.$confirm(`确认审核通过订单 ${row.orderNo} 吗？审核通过后将自动发放奖励。`, '审核通过', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/payManualOrder/audit', {
          id: row.id,
          status: 1,
          auditRemark: '审核通过'
        }).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message.success('审核成功，奖励已自动发放')
          this.getDataList()
        }).catch(() => {})
      }).catch(() => {})
    },

    // 审核拒绝
    handleReject(row) {
      this.rejectForm.id = row.id
      this.rejectForm.auditRemark = ''
      this.rejectDialogVisible = true
    },

    // 确认拒绝
    confirmReject() {
      if (!this.rejectForm.auditRemark) {
        return this.$message.warning('请选择或输入拒绝原因')
      }

      this.$http.post('/payManualOrder/audit', {
        id: this.rejectForm.id,
        status: 2,
        auditRemark: this.rejectForm.auditRemark
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message.success('审核完成')
        this.rejectDialogVisible = false
        this.getDataList()
      }).catch(() => {})
    },

    // 查看详情
    viewDetail(row) {
      this.currentOrder = row
      this.detailDialogVisible = true
    }
  }
}
</script>

<style scoped>
/* 待审核订单高亮 */
::v-deep .warning-row {
}

::v-deep .el-table .warning-row:hover > td {
}
::v-deep .el-table .cell {
    display: flex;
    justify-content: center;
    flex-direction: row;
}
    
</style>
